function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.78298 21.1862L2.7666 20.6052L14.0892 1.1886L15.1056 1.7696L3.78298 21.1862Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M2.53387 19.054H25.1791V20.216H2.53387V19.054Z",
  fill: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M14.3088 26.1818L2.98193 19.7068L3.56874 18.7005L14.8956 25.1755L14.3088 26.1818ZM24.1484 9.30629L12.8215 2.83129L13.4083 1.82497L24.7352 8.29997L24.1484 9.30629Z",
  fill: "currentColor"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M3.57186 9.30181L2.98505 8.29556L14.3119 1.82056L14.8987 2.82688L3.57186 9.30181Z",
  fill: "currentColor"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M23.9396 21.1864L12.617 1.76981L13.6333 1.18881L24.956 20.6054L23.9396 21.1864ZM3.43176 7.525H4.60538V20.475H3.43176V7.525ZM23.1146 7.525H24.2883V20.475H23.1146V7.525Z",
  fill: "currentColor"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M14.1089 25.69L13.5964 24.8109L23.4477 19.1794L23.9603 20.0584L14.1089 25.69Z",
  fill: "currentColor"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M25.8436 20.853C25.1649 22.022 23.6519 22.421 22.4712 21.749C21.2906 21.077 20.8876 19.579 21.5663 18.41C22.245 17.241 23.758 16.842 24.9387 17.514C26.1264 18.193 26.5294 19.684 25.8436 20.853ZM6.14661 9.59C5.46789 10.759 3.95491 11.158 2.77422 10.486C1.59353 9.814 1.19054 8.316 1.86926 7.147C2.54798 5.978 4.06096 5.579 5.24165 6.251C6.42234 6.93 6.82533 8.421 6.14661 9.59ZM1.87633 20.853C1.19761 19.684 1.6006 18.193 2.78129 17.514C3.96198 16.842 5.46789 17.241 6.15368 18.41C6.8324 19.579 6.42941 21.07 5.24872 21.749C4.06096 22.421 2.55505 22.022 1.87633 20.853ZM21.5734 9.59C20.8946 8.421 21.2976 6.93 22.4783 6.251C23.659 5.579 25.1649 5.978 25.8507 7.147C26.5294 8.316 26.1264 9.807 24.9457 10.486C23.7651 11.158 22.2521 10.759 21.5734 9.59ZM13.86 27.706C12.4955 27.706 11.3926 26.614 11.3926 25.263C11.3926 23.912 12.4955 22.82 13.86 22.82C15.2245 22.82 16.3274 23.912 16.3274 25.263C16.3274 26.607 15.2245 27.706 13.86 27.706ZM13.86 5.18C12.4955 5.18 11.3926 4.088 11.3926 2.737C11.3926 1.386 12.4955 0.294001 13.86 0.294001C15.2245 0.294001 16.3274 1.386 16.3274 2.737C16.3274 4.088 15.2245 5.18 13.86 5.18Z",
  fill: "currentColor"
});

var SvgGraphQl = function SvgGraphQl(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGraphQl, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/GraphQL.c6eaa613.svg";
export { ForwardRef as ReactComponent };